import { tokenIdentifier } from './../utils/staticData';

//token
export function getToken() {
    return sessionStorage.getItem(tokenIdentifier);
}

export function setToken(token) {
    sessionStorage.setItem(tokenIdentifier, token);
}

export function removeToken() {
    sessionStorage.removeItem(tokenIdentifier);
}

//username
export function getUsername() {
    return sessionStorage.getItem("username");
}

export function getGpsEnabled() {
    return sessionStorage.getItem("isGpsEnabled") === "true" ? true : false;
}

export function setUsername(username) {
    sessionStorage.setItem("username", username);
}

export function removeUsername() {
    sessionStorage.removeItem("username");
}

//subordinate user
export function getUserSubordination() {
    let status = sessionStorage.getItem("subordinate");
    if(status === undefined)
        return true;
    return status === "true" ? true : false;
}

export function setUserSubordination(value) {
    sessionStorage.setItem("subordinate", value);
}

export function removeUserSubordination() {
    sessionStorage.removeItem("subordinate");
}

export function getUserRole() {
    let status = sessionStorage.getItem("role");
    if(status === undefined)
        return "no_role";
    return status;
}

export function setUserRole(value) {
    sessionStorage.setItem("role", value);
}

export function removeUserRole() {
    sessionStorage.removeItem("role");
}


//login
export function getLogin() {
    return sessionStorage.getItem("login");
}

export function setLogin(login) {
    sessionStorage.setItem("login", login);
}

export function getIsPkp() {
    return JSON.parse(sessionStorage.getItem("isPKP"));
}

export function setIsPkp(isPKP) {
    sessionStorage.setItem("isPKP", JSON.stringify(isPKP));
}

export function removeIsPkp() {
    sessionStorage.removeItem("isPKP");
}

export function setGpsEnabled(login) {
    sessionStorage.setItem("isGpsEnabled", login);
}

export function removeGpsEnabled() {
    sessionStorage.removeItem("isGpsEnabled");
}

export function removeLogin() {
    sessionStorage.removeItem("login");
}

//rodo
export function getRodo() {
    let status = sessionStorage.getItem("rodo");
    if(status === undefined)
        return true;
    return status === "true" ? true : false;
}

export function setRodo(rodo) {
    sessionStorage.setItem("rodo", rodo);
}

export function removeRodo() {
    sessionStorage.removeItem("rodo");
}
